var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhoto(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 18.729,
    height: 18.729,
    viewBox: "0 0 18.729 18.729",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient",
    cx: 1.18,
    cy: 0.847,
    r: 0.637,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffcf7b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.195,
    stopColor: "#fecd76"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.439,
    stopColor: "#fac666"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#f3bc4d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.997,
    stopColor: "#eaad29"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#eaad29"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    y1: -0.002,
    x2: 0.5,
    y2: 1.017,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c26715"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.508,
    stopColor: "#b85515"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ad3f16"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icons8-picture",
    transform: "translate(-6 -6.307)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_53440",
    "data-name": "Path 53440",
    d: "M23.689,6H7.041A1.04,1.04,0,0,0,6,7.041V23.689a1.04,1.04,0,0,0,1.041,1.041H23.689a1.04,1.04,0,0,0,1.041-1.041V7.041A1.04,1.04,0,0,0,23.689,6Z",
    transform: "translate(0 0.307)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_53441",
    "data-name": "Path 53441",
    d: "M25.318,22.644a1.562,1.562,0,0,0-2.177-.03L18,27.484v5.011H29.446a1.04,1.04,0,0,0,1.041-1.041V27.812Z",
    transform: "translate(-5.757 -7.765)",
    fill: "#d6742d"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1555",
    "data-name": "Ellipse 1555",
    cx: 2.127,
    cy: 2.127,
    r: 2.127,
    transform: "translate(16.634 8.127)",
    fill: "#fff8de"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_53442",
    "data-name": "Path 53442",
    d: "M7.041,30.576H23.689a1.038,1.038,0,0,0,.947-.614L13.318,18.644a1.562,1.562,0,0,0-2.177-.03L6,23.484v6.052A1.04,1.04,0,0,0,7.041,30.576Z",
    transform: "translate(0 -5.846)",
    fill: "url(#linear-gradient)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoto);
export default __webpack_public_path__ + "static/media/photo.ef21b621c4659030ee45cf4552eda8bc.svg";
export { ForwardRef as ReactComponent };